export const ratesValidator = (fields) => {
  const errors = {};

  if (!fields.title || fields.title.trim() === "") {
    errors.title = "El título no puede estar vacío";
  }

  if (!fields.description || fields.description.trim() === "") {
    errors.description = "La descripción no puede estar vacío";
  }

  if (!fields.price || isNaN(fields.price)) {
    errors.price = "El precio no puede estar vacío.";
  }

  if (Array.isArray(fields.discounts)) {
    const discountsArray = [...fields.discounts];
    const fullDiscounts = discountsArray.filter(
      (element) =>
        element.discount_amount > 0 &&
        element.discount_type.length > 0 &&
        element.internet_id.length > 0
    );
    if (discountsArray.length !== fullDiscounts.length) {
      errors.discounts = "Los campos de los descuentos deben estar completos.";
    }
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/views/Configurator/utils/ratesVailidator.js